import { CancelToken } from 'axios';
import { awPortfolioManagementApi } from './Base';
import {
  AGraphCampaign,
  CampaignsResponse,
  GetCampaignsRequestParams,
  PutCampaignRequestBody,
  RemainingCapacity,
  UserActionsResponse,
} from './types';

const BASE_CAMPAIGN_PATH = 'campaigns/v1/campaigns';

export function getCampaignsUserActions(cancelToken?: CancelToken) {
  const path = `${BASE_CAMPAIGN_PATH}:getUserActions`;
  return awPortfolioManagementApi.get<UserActionsResponse>(path, {
    cancelToken,
  });
}

export function getCampaigns(params: GetCampaignsRequestParams, cancelToken?: CancelToken) {
  return awPortfolioManagementApi.get<CampaignsResponse>(BASE_CAMPAIGN_PATH, {
    params,
    cancelToken,
  });
}

export function postCreateCampaign(campaign: AGraphCampaign) {
  return awPortfolioManagementApi.post<AGraphCampaign>(BASE_CAMPAIGN_PATH, campaign);
}

export function putUpdateCampaign(requestBody: PutCampaignRequestBody, cancelToken?: CancelToken) {
  return awPortfolioManagementApi.put<AGraphCampaign>(BASE_CAMPAIGN_PATH, requestBody, {
    cancelToken,
  });
}

export function deleteCampaignById(id: string, cancelToken?: CancelToken) {
  const path = `${BASE_CAMPAIGN_PATH}/${id}`;
  return awPortfolioManagementApi.delete<AGraphCampaign>(path, {
    cancelToken,
  });
}

export function bulkDeleteCampaigns(campaignIds: string[], cancelToken?: CancelToken) {
  const path = `${BASE_CAMPAIGN_PATH}:batchDelete`;
  return awPortfolioManagementApi.post<void>(
    path,
    { campaignIds },
    {
      cancelToken,
    }
  );
}

export function batchUpdateCampaignStatuses(
  campaignIds: string[],
  campaignStatus: string,
  userComment?: string,
  cancelToken?: CancelToken
) {
  const path = `${BASE_CAMPAIGN_PATH}:batchUpdateCampaignStatuses`;
  return awPortfolioManagementApi.post<{
    campaigns: AGraphCampaign[];
  }>(
    path,
    { campaignIds, campaignStatus, userComment },
    {
      cancelToken,
    }
  );
}

export function getCampaignById(id: string, cancelToken?: CancelToken) {
  const path = `${BASE_CAMPAIGN_PATH}/${id}`;
  return awPortfolioManagementApi.get<AGraphCampaign>(path, {
    cancelToken,
  });
}

export function postBatchCampaigns(campaignIds: string[], pkg: string) {
  const path = `${BASE_CAMPAIGN_PATH}:batchGet`;
  return awPortfolioManagementApi.post<{
    campaigns: AGraphCampaign[];
  }>(path, { campaignIds }, { params: { pkg } });
}

// todo: integration
export function cloneCampaign(campaignId: string) {
  const path = `${BASE_CAMPAIGN_PATH}/${campaignId}:clone`;
  return awPortfolioManagementApi.post<AGraphCampaign>(path);
}

export function postUpdateCampaignStatus(campaignId: string, campaignStatus: string) {
  const path = `${BASE_CAMPAIGN_PATH}/${campaignId}/status`;
  return awPortfolioManagementApi.post<AGraphCampaign>(path, { campaignStatus, userComment: '' });
}

export function getCampaignsByStatuses({
  statuses,
  pageSize = 1000,
  pageToken = '',
}: {
  statuses: string[];
  pageSize?: number;
  pageToken?: string;
}) {
  const path = `${BASE_CAMPAIGN_PATH}:filterByStatus`;
  return awPortfolioManagementApi.post<CampaignsResponse>(path, {
    statuses,
    pageSize,
    pageToken,
  });
}

export function getCampaignsRemainingCapacity() {
  const path = `${BASE_CAMPAIGN_PATH}:evaluateRemainingCapacity`;
  return awPortfolioManagementApi.get<RemainingCapacity>(path);
}

// TODO: Add more APIs for Campaigns related
